module.exports = __webpack_public_path__ + "static/media/preloader.03527c20.svg";